import { useContext, useState } from "react";
import UserContext from "../context/user";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useTealiumOnPageLoad from "../utils/tealium";
import AppError from "../components/app-error";
import ForgotPassword from "./forgot-password";
import CookiePolicy from "./cookie-policy";
import AppsLogin from "./apps-login";
import CookieBanner from "../components/cookie-banner";
import OsteopataContext from "../context/osteopata";
import Header from "../components/header";
import CmsPage from "../components/cms-page";
import Footer from "../components/footer";
import OsteopataBody from "../components/osteopata/osteopata-body";

const APP = "OSTEOPATA";

const OsteopataRoute = () => {
  const { logged } = useContext(UserContext);
  const {
    survey,
    error,
    appLang,
    languages,
    labels,
    navigation,
    osteopataInfo,
    setAppLang,
    setNavigation,
  } = useContext(OsteopataContext);
  const [forgotPw, setForgotPw] = useState();

  useTealiumOnPageLoad({ pageSection1: "welfare", pageSection2: "Osteopata" });
  useDocumentTitle("EssilorLuxottica Osteopata");

  return (
    <>
      {error ? (
        <AppError error={error} labels={labels} />
      ) : logged ? (
        Object.entries(labels).length === 0 ? (
          <div className="loading-spinner mt" />
        ) : (
          <>
            <Header
              selectedLanguage={appLang}
              setSelectedLanguage={setAppLang}
              languages={languages}
              labels={labels}
              app={APP}
              appTitle={survey?.title}
            />
            <main className="app-content osteopata-content">
              {["privacy-policy", "cookie-policy"]?.includes(navigation) ? (
                {
                  "privacy-policy": (
                    <CmsPage
                      path="footer/privacy-policy"
                      title={labels?.WELFARE_PRIVACY_POLICY}
                      setNavigation={setNavigation}
                      key={navigation}
                      appLang={appLang}
                    />
                  ),
                  "cookie-policy": (
                    <CookiePolicy logged={true} setNavigation={setNavigation} appLang={appLang} />
                  ),
                }[navigation]
              ) : error ? (
                <AppError error={error} labels={labels} />
              ) : !survey ? (
                <div className="loading-spinner mt" />
              ) : (
                <OsteopataBody />
              )}
            </main>
            <Footer
              setNavigation={setNavigation}
              app={APP}
              labels={labels}
              title={osteopataInfo?.title}
            />
          </>
        )
      ) : forgotPw ? (
        <ForgotPassword setForgotPw={setForgotPw} labels={labels} />
      ) : navigation === "cookie-policy" ? (
        <CookiePolicy logged={false} setNavigation={setNavigation} appLang={appLang} />
      ) : (
        <AppsLogin app={APP} setForgotPw={setForgotPw} labels={labels} />
      )}
      <CookieBanner labels={labels} setNavigation={setNavigation} />
    </>
  );
};

export default OsteopataRoute;
